<template>
  <div id="enterprise-agency-insert-data">
    <enterprise-agency-form
      mode="insert"
    >
    </enterprise-agency-form>
  </div>
</template>

<script>

import EnterpriseAgencyForm from "./EnterpriseAgencyForm";

export default {
  components: {
    EnterpriseAgencyForm,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
